import { apiShareBulk } from '../../../../common/api/lesson'

const changeActiveTab = tabName => ({
  type: 'LESSON_LIST:CHANGE_ACTIVE_TAB',
  tabName
})

const showDeleteLessonDialog = lessonId => ({
  type: 'LESSON_LIST:SHOW_DELETE_LESSON_DIALOG',
  lessonId
})

const closeDeleteLessonDialog = lessonId => ({
  type: 'LESSON_LIST:CLOSE_DELETE_LESSON_DIALOG'
})

const openShareModal = id => ({ type: 'LESSON_LIST:OPEN_SHARE_MODAL', id })
const closeShareModal = () => ({ type: 'LESSON_LIST:CLOSE_SHARE_MODAL' })

const shareLesson = (presentationId, { emails, recaptchaToken, message }) => ({
  requestPrefix: 'LESSON_LIST:SHARE',
  params: { presentationId, emails },
  request: () => {
    const payload = {
      presentation_id: presentationId,
      emails,
      recaptcha_token: recaptchaToken
    }
    if (message) payload.message = message

    return apiShareBulk(payload)
  }
})

export {
  changeActiveTab,
  showDeleteLessonDialog,
  closeDeleteLessonDialog,
  shareLesson,
  openShareModal,
  closeShareModal
}
